function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function about() {
  return import(/* webpackChunkName: "page-about" */ '@/pages/about.vue')
}
function authLogin() {
  return import(
    /* webpackChunkName: "page-authLogin" */ '@/pages/authLogin.vue'
  )
}
function emp_number() {
  return import(
    /* webpackChunkName: "page-emp_number" */ '@/pages/emp_number.vue'
  )
}
function emp_number_intranet() {
  return import(
    /* webpackChunkName: "page-emp_number_intranet" */ '@/pages/emp_number_intranet.vue'
  )
}
function familysite_admin() {
  return import(
    /* webpackChunkName: "page-familysite_admin" */ '@/pages/familysite_admin.vue'
  )
}
function gate_login() {
  return import(
    /* webpackChunkName: "page-gate_login" */ '@/pages/gate_login.vue'
  )
}
function index_copy() {
  return import(
    /* webpackChunkName: "page-index copy" */ '@/pages/index copy.vue'
  )
}
function leadership() {
  return import(
    /* webpackChunkName: "page-leadership" */ '@/pages/leadership.vue'
  )
}
function leadership_apply() {
  return import(
    /* webpackChunkName: "page-leadership_apply" */ '@/pages/leadership_apply.vue'
  )
}
function login() {
  return import(/* webpackChunkName: "page-login" */ '@/pages/login.vue')
}
function main() {
  return import(/* webpackChunkName: "page-main" */ '@/pages/main.vue')
}
function pwdChange() {
  return import(
    /* webpackChunkName: "page-pwdChange" */ '@/pages/pwdChange.vue'
  )
}
function stage_____() {
  return import(
    /* webpackChunkName: "page-stage (원본)" */ '@/pages/stage (원본).vue'
  )
}
function stage() {
  return import(/* webpackChunkName: "page-stage" */ '@/pages/stage.vue')
}
function system_select() {
  return import(
    /* webpackChunkName: "page-system_select" */ '@/pages/system_select.vue'
  )
}
function test() {
  return import(/* webpackChunkName: "page-test" */ '@/pages/test.vue')
}
function BusinessManagement_ERAdd() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ERAdd" */ '@/pages/BusinessManagement/ERAdd.vue'
  )
}
function BusinessManagement_ERList() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ERList" */ '@/pages/BusinessManagement/ERList.vue'
  )
}
function BusinessManagement_ManagementPlanAdd() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ManagementPlanAdd" */ '@/pages/BusinessManagement/ManagementPlanAdd.vue'
  )
}
function BusinessManagement_ManagementPlanList() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ManagementPlanList" */ '@/pages/BusinessManagement/ManagementPlanList.vue'
  )
}
function BusinessManagement_ResearchAdd() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ResearchAdd" */ '@/pages/BusinessManagement/ResearchAdd.vue'
  )
}
function BusinessManagement_ResearchList() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ResearchList" */ '@/pages/BusinessManagement/ResearchList.vue'
  )
}
function BusinessManagement_SPACAdd() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-SPACAdd" */ '@/pages/BusinessManagement/SPACAdd.vue'
  )
}
function BusinessManagement_SPACList() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-SPACList" */ '@/pages/BusinessManagement/SPACList.vue'
  )
}
function BusinessManagement_eLearningAdd() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-eLearningAdd" */ '@/pages/BusinessManagement/eLearningAdd.vue'
  )
}
function BusinessManagement_eLearningList() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-eLearningList" */ '@/pages/BusinessManagement/eLearningList.vue'
  )
}
function CARROTZone_CEOMessageAdd() {
  return import(
    /* webpackChunkName: "page-CARROTZone-CEOMessageAdd" */ '@/pages/CARROTZone/CEOMessageAdd.vue'
  )
}
function CARROTZone_CEOMessageList() {
  return import(
    /* webpackChunkName: "page-CARROTZone-CEOMessageList" */ '@/pages/CARROTZone/CEOMessageList.vue'
  )
}
function CARROTZone_CarrotManualAdd() {
  return import(
    /* webpackChunkName: "page-CARROTZone-CarrotManualAdd" */ '@/pages/CARROTZone/CarrotManualAdd.vue'
  )
}
function CARROTZone_CarrotManualList() {
  return import(
    /* webpackChunkName: "page-CARROTZone-CarrotManualList" */ '@/pages/CARROTZone/CarrotManualList.vue'
  )
}
function CARROTZone_MediaZoneAdd() {
  return import(
    /* webpackChunkName: "page-CARROTZone-MediaZoneAdd" */ '@/pages/CARROTZone/MediaZoneAdd.vue'
  )
}
function CARROTZone_MediaZoneList() {
  return import(
    /* webpackChunkName: "page-CARROTZone-MediaZoneList" */ '@/pages/CARROTZone/MediaZoneList.vue'
  )
}
function CARROTZone_NoticeAdd() {
  return import(
    /* webpackChunkName: "page-CARROTZone-NoticeAdd" */ '@/pages/CARROTZone/NoticeAdd.vue'
  )
}
function CARROTZone_NoticeList() {
  return import(
    /* webpackChunkName: "page-CARROTZone-NoticeList" */ '@/pages/CARROTZone/NoticeList.vue'
  )
}
function ResourceManagement_ClassroomReservationAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ClassroomReservationAdd" */ '@/pages/ResourceManagement/ClassroomReservationAdd.vue'
  )
}
function ResourceManagement_ClassroomReservationDate() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ClassroomReservationDate" */ '@/pages/ResourceManagement/ClassroomReservationDate.vue'
  )
}
function ResourceManagement_ClassroomReservationMonth() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ClassroomReservationMonth" */ '@/pages/ResourceManagement/ClassroomReservationMonth.vue'
  )
}
function ResourceManagement_ClassroomReservationStatistics() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ClassroomReservationStatistics" */ '@/pages/ResourceManagement/ClassroomReservationStatistics.vue'
  )
}
function ResourceManagement_ClassroomReservationWeek() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ClassroomReservationWeek" */ '@/pages/ResourceManagement/ClassroomReservationWeek.vue'
  )
}
function ResourceManagement_FuelCostMangementList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-FuelCostMangementList" */ '@/pages/ResourceManagement/FuelCostMangementList.vue'
  )
}
function ResourceManagement_MIScheduleAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MIScheduleAdd" */ '@/pages/ResourceManagement/MIScheduleAdd.vue'
  )
}
function ResourceManagement_MIScheduleDate() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MIScheduleDate" */ '@/pages/ResourceManagement/MIScheduleDate.vue'
  )
}
function ResourceManagement_MIScheduleMonth() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MIScheduleMonth" */ '@/pages/ResourceManagement/MIScheduleMonth.vue'
  )
}
function ResourceManagement_MIVacationAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MIVacationAdd" */ '@/pages/ResourceManagement/MIVacationAdd.vue'
  )
}
function ResourceManagement_MagazineManagementAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MagazineManagementAdd" */ '@/pages/ResourceManagement/MagazineManagementAdd.vue'
  )
}
function ResourceManagement_MagazineManagementList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MagazineManagementList" */ '@/pages/ResourceManagement/MagazineManagementList.vue'
  )
}
function ResourceManagement_NewsLetterManagementAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementAdd" */ '@/pages/ResourceManagement/NewsLetterManagementAdd.vue'
  )
}
function ResourceManagement_NewsLetterManagementList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementList" */ '@/pages/ResourceManagement/NewsLetterManagementList.vue'
  )
}
function ResourceManagement_ReturnStatusMaintenanceList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ReturnStatusMaintenanceList" */ '@/pages/ResourceManagement/ReturnStatusMaintenanceList.vue'
  )
}
function ResourceManagement_ShipmentStatusMaintenanceAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ShipmentStatusMaintenanceAdd" */ '@/pages/ResourceManagement/ShipmentStatusMaintenanceAdd.vue'
  )
}
function ResourceManagement_ShipmentStatusMaintenanceList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ShipmentStatusMaintenanceList" */ '@/pages/ResourceManagement/ShipmentStatusMaintenanceList.vue'
  )
}
function ResourceManagement_ShipmentStatusMaintenanceView() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ShipmentStatusMaintenanceView" */ '@/pages/ResourceManagement/ShipmentStatusMaintenanceView.vue'
  )
}
function ResourceManagement_StudioReservationAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-StudioReservationAdd" */ '@/pages/ResourceManagement/StudioReservationAdd.vue'
  )
}
function ResourceManagement_StudioReservationMonth() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-StudioReservationMonth" */ '@/pages/ResourceManagement/StudioReservationMonth.vue'
  )
}
function ResourceManagement_TextbookRentalAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TextbookRentalAdd" */ '@/pages/ResourceManagement/TextbookRentalAdd.vue'
  )
}
function ResourceManagement_TextbookRentalList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TextbookRentalList" */ '@/pages/ResourceManagement/TextbookRentalList.vue'
  )
}
function ResourceManagement_TextbookReturnList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TextbookReturnList" */ '@/pages/ResourceManagement/TextbookReturnList.vue'
  )
}
function ResourceManagement_TextbookStatisticsList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TextbookStatisticsList" */ '@/pages/ResourceManagement/TextbookStatisticsList.vue'
  )
}
function ResourceManagement_TutorTextbookAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TutorTextbookAdd" */ '@/pages/ResourceManagement/TutorTextbookAdd.vue'
  )
}
function ResourceManagement_TutorTextbookList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TutorTextbookList" */ '@/pages/ResourceManagement/TutorTextbookList.vue'
  )
}
function ResourceManagement_VehicleReservationAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-VehicleReservationAdd" */ '@/pages/ResourceManagement/VehicleReservationAdd.vue'
  )
}
function ResourceManagement_VehicleReservationLogDay() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-VehicleReservationLogDay" */ '@/pages/ResourceManagement/VehicleReservationLogDay.vue'
  )
}
function ResourceManagement_VehicleReservationLogMonth() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-VehicleReservationLogMonth" */ '@/pages/ResourceManagement/VehicleReservationLogMonth.vue'
  )
}
function ResourceManagement_textbookMaintenanceAdd() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-textbookMaintenanceAdd" */ '@/pages/ResourceManagement/textbookMaintenanceAdd.vue'
  )
}
function ResourceManagement_textbookMaintenanceList() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-textbookMaintenanceList" */ '@/pages/ResourceManagement/textbookMaintenanceList.vue'
  )
}
function TaskManagement_taskAdd() {
  return import(
    /* webpackChunkName: "page-TaskManagement-taskAdd" */ '@/pages/TaskManagement/taskAdd.vue'
  )
}
function TaskManagement_taskList() {
  return import(
    /* webpackChunkName: "page-TaskManagement-taskList" */ '@/pages/TaskManagement/taskList.vue'
  )
}
function customerManagement_businessCardAdd() {
  return import(
    /* webpackChunkName: "page-customerManagement-businessCardAdd" */ '@/pages/customerManagement/businessCardAdd.vue'
  )
}
function customerManagement_businessCardList() {
  return import(
    /* webpackChunkName: "page-customerManagement-businessCardList" */ '@/pages/customerManagement/businessCardList.vue'
  )
}
function customerManagement_customerDBAdd() {
  return import(
    /* webpackChunkName: "page-customerManagement-customerDBAdd" */ '@/pages/customerManagement/customerDBAdd.vue'
  )
}
function customerManagement_customerDBList() {
  return import(
    /* webpackChunkName: "page-customerManagement-customerDBList" */ '@/pages/customerManagement/customerDBList.vue'
  )
}
function customerManagement_customerStatus() {
  return import(
    /* webpackChunkName: "page-customerManagement-customerStatus" */ '@/pages/customerManagement/customerStatus.vue'
  )
}
function customerManagement_inboundDashboard() {
  return import(
    /* webpackChunkName: "page-customerManagement-inboundDashboard" */ '@/pages/customerManagement/inboundDashboard.vue'
  )
}
function customerManagement_scheduleVisitAdd() {
  return import(
    /* webpackChunkName: "page-customerManagement-scheduleVisitAdd" */ '@/pages/customerManagement/scheduleVisitAdd.vue'
  )
}
function customerManagement_scheduleVisitList() {
  return import(
    /* webpackChunkName: "page-customerManagement-scheduleVisitList" */ '@/pages/customerManagement/scheduleVisitList.vue'
  )
}
function customerManagement_scheduleVisitMonthly() {
  return import(
    /* webpackChunkName: "page-customerManagement-scheduleVisitMonthly" */ '@/pages/customerManagement/scheduleVisitMonthly.vue'
  )
}
function customerManagement_scheduleVisitStatus() {
  return import(
    /* webpackChunkName: "page-customerManagement-scheduleVisitStatus" */ '@/pages/customerManagement/scheduleVisitStatus.vue'
  )
}
function customerManagement_scheduleVisitWeekly() {
  return import(
    /* webpackChunkName: "page-customerManagement-scheduleVisitWeekly" */ '@/pages/customerManagement/scheduleVisitWeekly.vue'
  )
}
function customerManagement_statusCarrotTotalSalesList() {
  return import(
    /* webpackChunkName: "page-customerManagement-statusCarrotTotalSalesList" */ '@/pages/customerManagement/statusCarrotTotalSalesList.vue'
  )
}
function customerManagement_statusCarrotTotalSalesList2() {
  return import(
    /* webpackChunkName: "page-customerManagement-statusCarrotTotalSalesList2" */ '@/pages/customerManagement/statusCarrotTotalSalesList2.vue'
  )
}
function customerManagement_statusSMPAdd() {
  return import(
    /* webpackChunkName: "page-customerManagement-statusSMPAdd" */ '@/pages/customerManagement/statusSMPAdd.vue'
  )
}
function customerManagement_statusSMPList() {
  return import(
    /* webpackChunkName: "page-customerManagement-statusSMPList" */ '@/pages/customerManagement/statusSMPList.vue'
  )
}
function documents_AllDocumentList() {
  return import(
    /* webpackChunkName: "page-documents-AllDocumentList" */ '@/pages/documents/AllDocumentList.vue'
  )
}
function documents_AllExpenseList() {
  return import(
    /* webpackChunkName: "page-documents-AllExpenseList" */ '@/pages/documents/AllExpenseList.vue'
  )
}
function documents_AllExtraPayList() {
  return import(
    /* webpackChunkName: "page-documents-AllExtraPayList" */ '@/pages/documents/AllExtraPayList.vue'
  )
}
function documents_AllStatisticsList() {
  return import(
    /* webpackChunkName: "page-documents-AllStatisticsList" */ '@/pages/documents/AllStatisticsList.vue'
  )
}
function documents_DeptInboxList() {
  return import(
    /* webpackChunkName: "page-documents-DeptInboxList" */ '@/pages/documents/DeptInboxList.vue'
  )
}
function documents_DraftingAdd() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd" */ '@/pages/documents/DraftingAdd.vue'
  )
}
function documents_DraftingAdd1() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd1" */ '@/pages/documents/DraftingAdd1.vue'
  )
}
function documents_DraftingAdd10() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd10" */ '@/pages/documents/DraftingAdd10.vue'
  )
}
function documents_DraftingAdd2() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd2" */ '@/pages/documents/DraftingAdd2.vue'
  )
}
function documents_DraftingAdd3() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd3" */ '@/pages/documents/DraftingAdd3.vue'
  )
}
function documents_DraftingAdd4() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd4" */ '@/pages/documents/DraftingAdd4.vue'
  )
}
function documents_DraftingAdd5() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd5" */ '@/pages/documents/DraftingAdd5.vue'
  )
}
function documents_DraftingAdd6() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd6" */ '@/pages/documents/DraftingAdd6.vue'
  )
}
function documents_DraftingAdd7() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd7" */ '@/pages/documents/DraftingAdd7.vue'
  )
}
function documents_DraftingAdd8() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd8" */ '@/pages/documents/DraftingAdd8.vue'
  )
}
function documents_DraftingAdd9() {
  return import(
    /* webpackChunkName: "page-documents-DraftingAdd9" */ '@/pages/documents/DraftingAdd9.vue'
  )
}
function documents_ExpenseInputAdd() {
  return import(
    /* webpackChunkName: "page-documents-ExpenseInputAdd" */ '@/pages/documents/ExpenseInputAdd.vue'
  )
}
function documents_MyExpenseManagement() {
  return import(
    /* webpackChunkName: "page-documents-MyExpenseManagement" */ '@/pages/documents/MyExpenseManagement.vue'
  )
}
function documents_MyExtraPayManagement() {
  return import(
    /* webpackChunkName: "page-documents-MyExtraPayManagement" */ '@/pages/documents/MyExtraPayManagement.vue'
  )
}
function documents_SalesManagementNotPublishList() {
  return import(
    /* webpackChunkName: "page-documents-SalesManagementNotPublishList" */ '@/pages/documents/SalesManagementNotPublishList.vue'
  )
}
function documents_SalesManagementPublishAdd() {
  return import(
    /* webpackChunkName: "page-documents-SalesManagementPublishAdd" */ '@/pages/documents/SalesManagementPublishAdd.vue'
  )
}
function documents_SalesManagementPublishList() {
  return import(
    /* webpackChunkName: "page-documents-SalesManagementPublishList" */ '@/pages/documents/SalesManagementPublishList.vue'
  )
}
function documents_SalesManagementPublishView() {
  return import(
    /* webpackChunkName: "page-documents-SalesManagementPublishView" */ '@/pages/documents/SalesManagementPublishView.vue'
  )
}
function documents_TotalSalesAmountList() {
  return import(
    /* webpackChunkName: "page-documents-TotalSalesAmountList" */ '@/pages/documents/TotalSalesAmountList.vue'
  )
}
function myPIMS_AllVacationList() {
  return import(
    /* webpackChunkName: "page-myPIMS-AllVacationList" */ '@/pages/myPIMS/AllVacationList.vue'
  )
}
function myPIMS_AssetDisposalList() {
  return import(
    /* webpackChunkName: "page-myPIMS-AssetDisposalList" */ '@/pages/myPIMS/AssetDisposalList.vue'
  )
}
function myPIMS_AssetManagementAdd() {
  return import(
    /* webpackChunkName: "page-myPIMS-AssetManagementAdd" */ '@/pages/myPIMS/AssetManagementAdd.vue'
  )
}
function myPIMS_AssetManagementList() {
  return import(
    /* webpackChunkName: "page-myPIMS-AssetManagementList" */ '@/pages/myPIMS/AssetManagementList.vue'
  )
}
function myPIMS_AssetManagementReportAdd() {
  return import(
    /* webpackChunkName: "page-myPIMS-AssetManagementReportAdd" */ '@/pages/myPIMS/AssetManagementReportAdd.vue'
  )
}
function myPIMS_AssetManagementReportList() {
  return import(
    /* webpackChunkName: "page-myPIMS-AssetManagementReportList" */ '@/pages/myPIMS/AssetManagementReportList.vue'
  )
}
function myPIMS_AssetReportList() {
  return import(
    /* webpackChunkName: "page-myPIMS-AssetReportList" */ '@/pages/myPIMS/AssetReportList.vue'
  )
}
function myPIMS_CommunicationPledge() {
  return import(
    /* webpackChunkName: "page-myPIMS-CommunicationPledge" */ '@/pages/myPIMS/CommunicationPledge.vue'
  )
}
function myPIMS_EducationAdd() {
  return import(
    /* webpackChunkName: "page-myPIMS-EducationAdd" */ '@/pages/myPIMS/EducationAdd.vue'
  )
}
function myPIMS_EducationDashboard() {
  return import(
    /* webpackChunkName: "page-myPIMS-EducationDashboard" */ '@/pages/myPIMS/EducationDashboard.vue'
  )
}
function myPIMS_EducationList() {
  return import(
    /* webpackChunkName: "page-myPIMS-EducationList" */ '@/pages/myPIMS/EducationList.vue'
  )
}
function myPIMS_EmployeeAdd() {
  return import(
    /* webpackChunkName: "page-myPIMS-EmployeeAdd" */ '@/pages/myPIMS/EmployeeAdd.vue'
  )
}
function myPIMS_FeedbackList() {
  return import(
    /* webpackChunkName: "page-myPIMS-FeedbackList" */ '@/pages/myPIMS/FeedbackList.vue'
  )
}
function myPIMS_GoodsRentalAdd() {
  return import(
    /* webpackChunkName: "page-myPIMS-GoodsRentalAdd" */ '@/pages/myPIMS/GoodsRentalAdd.vue'
  )
}
function myPIMS_GoodsRentalList_tab1() {
  return import(
    /* webpackChunkName: "page-myPIMS-GoodsRentalList_tab1" */ '@/pages/myPIMS/GoodsRentalList_tab1.vue'
  )
}
function myPIMS_GoodsRentalList_tab2() {
  return import(
    /* webpackChunkName: "page-myPIMS-GoodsRentalList_tab2" */ '@/pages/myPIMS/GoodsRentalList_tab2.vue'
  )
}
function myPIMS_HeadTeamManagement() {
  return import(
    /* webpackChunkName: "page-myPIMS-HeadTeamManagement" */ '@/pages/myPIMS/HeadTeamManagement.vue'
  )
}
function myPIMS_HeadTeamManagement22() {
  return import(
    /* webpackChunkName: "page-myPIMS-HeadTeamManagement22" */ '@/pages/myPIMS/HeadTeamManagement22.vue'
  )
}
function myPIMS_HoliDayGift() {
  return import(
    /* webpackChunkName: "page-myPIMS-HoliDayGift" */ '@/pages/myPIMS/HoliDayGift.vue'
  )
}
function myPIMS_HolidayList() {
  return import(
    /* webpackChunkName: "page-myPIMS-HolidayList" */ '@/pages/myPIMS/HolidayList.vue'
  )
}
function myPIMS_IMOverallstatisticsList() {
  return import(
    /* webpackChunkName: "page-myPIMS-IMOverallstatisticsList" */ '@/pages/myPIMS/IMOverallstatisticsList.vue'
  )
}
function myPIMS_IncumbentManagementList() {
  return import(
    /* webpackChunkName: "page-myPIMS-IncumbentManagementList" */ '@/pages/myPIMS/IncumbentManagementList.vue'
  )
}
function myPIMS_JobRotationManagementList() {
  return import(
    /* webpackChunkName: "page-myPIMS-JobRotationManagementList" */ '@/pages/myPIMS/JobRotationManagementList.vue'
  )
}
function myPIMS_KPIAdd() {
  return import(
    /* webpackChunkName: "page-myPIMS-KPIAdd" */ '@/pages/myPIMS/KPIAdd.vue'
  )
}
function myPIMS_MCGList() {
  return import(
    /* webpackChunkName: "page-myPIMS-MCGList" */ '@/pages/myPIMS/MCGList.vue'
  )
}
function myPIMS_MCRList() {
  return import(
    /* webpackChunkName: "page-myPIMS-MCRList" */ '@/pages/myPIMS/MCRList.vue'
  )
}
function myPIMS_MyCommunicationPledge() {
  return import(
    /* webpackChunkName: "page-myPIMS-MyCommunicationPledge" */ '@/pages/myPIMS/MyCommunicationPledge.vue'
  )
}
function myPIMS_PBCAdd() {
  return import(
    /* webpackChunkName: "page-myPIMS-PBCAdd" */ '@/pages/myPIMS/PBCAdd.vue'
  )
}
function myPIMS_PBCKPIList() {
  return import(
    /* webpackChunkName: "page-myPIMS-PBCKPIList" */ '@/pages/myPIMS/PBCKPIList.vue'
  )
}
function myPIMS_RecruitList() {
  return import(
    /* webpackChunkName: "page-myPIMS-RecruitList" */ '@/pages/myPIMS/RecruitList.vue'
  )
}
function myPIMS_RetireeManagementList() {
  return import(
    /* webpackChunkName: "page-myPIMS-RetireeManagementList" */ '@/pages/myPIMS/RetireeManagementList.vue'
  )
}
function myPIMS_TeamEvaluationManagementList() {
  return import(
    /* webpackChunkName: "page-myPIMS-TeamEvaluationManagementList" */ '@/pages/myPIMS/TeamEvaluationManagementList.vue'
  )
}
function myPIMS_TeamVacationList() {
  return import(
    /* webpackChunkName: "page-myPIMS-TeamVacationList" */ '@/pages/myPIMS/TeamVacationList.vue'
  )
}
function myPIMS_TelecommutingList() {
  return import(
    /* webpackChunkName: "page-myPIMS-TelecommutingList" */ '@/pages/myPIMS/TelecommutingList.vue'
  )
}
function myPIMS_VacationLog() {
  return import(
    /* webpackChunkName: "page-myPIMS-VacationLog" */ '@/pages/myPIMS/VacationLog.vue'
  )
}
function myPIMS_VacationManagement() {
  return import(
    /* webpackChunkName: "page-myPIMS-VacationManagement" */ '@/pages/myPIMS/VacationManagement.vue'
  )
}
function myPIMS_eicn() {
  return import(
    /* webpackChunkName: "page-myPIMS-eicn" */ '@/pages/myPIMS/eicn.vue'
  )
}
function myPIMS_myAssetList() {
  return import(
    /* webpackChunkName: "page-myPIMS-myAssetList" */ '@/pages/myPIMS/myAssetList.vue'
  )
}
function myPIMS_myEduManagemetList() {
  return import(
    /* webpackChunkName: "page-myPIMS-myEduManagemetList" */ '@/pages/myPIMS/myEduManagemetList.vue'
  )
}
function myPIMS_myVacationList() {
  return import(
    /* webpackChunkName: "page-myPIMS-myVacationList" */ '@/pages/myPIMS/myVacationList.vue'
  )
}
function personality_MypimsPersonalityAdd() {
  return import(
    /* webpackChunkName: "page-personality-MypimsPersonalityAdd" */ '@/pages/personality/MypimsPersonalityAdd.vue'
  )
}
function personality_MypimsPersonalityList() {
  return import(
    /* webpackChunkName: "page-personality-MypimsPersonalityList" */ '@/pages/personality/MypimsPersonalityList.vue'
  )
}
function personality_MypimsPersonalityView() {
  return import(
    /* webpackChunkName: "page-personality-MypimsPersonalityView" */ '@/pages/personality/MypimsPersonalityView.vue'
  )
}
function BusinessManagement_ERCompleteList__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ERCompleteList-idx" */ '@/pages/BusinessManagement/ERCompleteList/_idx.vue'
  )
}
function BusinessManagement_EREtcList__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-EREtcList-idx" */ '@/pages/BusinessManagement/EREtcList/_idx.vue'
  )
}
function BusinessManagement_ERMod__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ERMod-idx" */ '@/pages/BusinessManagement/ERMod/_idx.vue'
  )
}
function BusinessManagement_ERView__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ERView-idx" */ '@/pages/BusinessManagement/ERView/_idx.vue'
  )
}
function BusinessManagement_ManagementPlanMod__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ManagementPlanMod-idx" */ '@/pages/BusinessManagement/ManagementPlanMod/_idx.vue'
  )
}
function BusinessManagement_ManagementPlanView__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ManagementPlanView-idx" */ '@/pages/BusinessManagement/ManagementPlanView/_idx.vue'
  )
}
function BusinessManagement_ResearchMod__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ResearchMod-idx" */ '@/pages/BusinessManagement/ResearchMod/_idx.vue'
  )
}
function BusinessManagement_ResearchView__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-ResearchView-idx" */ '@/pages/BusinessManagement/ResearchView/_idx.vue'
  )
}
function BusinessManagement_SPACMod__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-SPACMod-idx" */ '@/pages/BusinessManagement/SPACMod/_idx.vue'
  )
}
function BusinessManagement_SPACView__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-SPACView-idx" */ '@/pages/BusinessManagement/SPACView/_idx.vue'
  )
}
function BusinessManagement_eLearningMod__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-eLearningMod-idx" */ '@/pages/BusinessManagement/eLearningMod/_idx.vue'
  )
}
function BusinessManagement_eLearningView__idx() {
  return import(
    /* webpackChunkName: "page-BusinessManagement-eLearningView-idx" */ '@/pages/BusinessManagement/eLearningView/_idx.vue'
  )
}
function CARROTZone_CEOMessageMod__idx() {
  return import(
    /* webpackChunkName: "page-CARROTZone-CEOMessageMod-idx" */ '@/pages/CARROTZone/CEOMessageMod/_idx.vue'
  )
}
function CARROTZone_CEOMessageView__idx() {
  return import(
    /* webpackChunkName: "page-CARROTZone-CEOMessageView-idx" */ '@/pages/CARROTZone/CEOMessageView/_idx.vue'
  )
}
function CARROTZone_CarrotManualMod__idx() {
  return import(
    /* webpackChunkName: "page-CARROTZone-CarrotManualMod-idx" */ '@/pages/CARROTZone/CarrotManualMod/_idx.vue'
  )
}
function CARROTZone_CarrotManualView__idx() {
  return import(
    /* webpackChunkName: "page-CARROTZone-CarrotManualView-idx" */ '@/pages/CARROTZone/CarrotManualView/_idx.vue'
  )
}
function CARROTZone_MediaZoneMod__idx() {
  return import(
    /* webpackChunkName: "page-CARROTZone-MediaZoneMod-idx" */ '@/pages/CARROTZone/MediaZoneMod/_idx.vue'
  )
}
function CARROTZone_MediaZoneView__idx() {
  return import(
    /* webpackChunkName: "page-CARROTZone-MediaZoneView-idx" */ '@/pages/CARROTZone/MediaZoneView/_idx.vue'
  )
}
function CARROTZone_NoticeMod__idx() {
  return import(
    /* webpackChunkName: "page-CARROTZone-NoticeMod-idx" */ '@/pages/CARROTZone/NoticeMod/_idx.vue'
  )
}
function CARROTZone_NoticeView__idx() {
  return import(
    /* webpackChunkName: "page-CARROTZone-NoticeView-idx" */ '@/pages/CARROTZone/NoticeView/_idx.vue'
  )
}
function ResourceManagement_ClassroomReservationMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-ClassroomReservationMod-idx" */ '@/pages/ResourceManagement/ClassroomReservationMod/_idx.vue'
  )
}
function ResourceManagement_MIScheduleMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MIScheduleMod-idx" */ '@/pages/ResourceManagement/MIScheduleMod/_idx.vue'
  )
}
function ResourceManagement_MIVacationMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MIVacationMod-idx" */ '@/pages/ResourceManagement/MIVacationMod/_idx.vue'
  )
}
function ResourceManagement_MagazineManagementMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MagazineManagementMod-idx" */ '@/pages/ResourceManagement/MagazineManagementMod/_idx.vue'
  )
}
function ResourceManagement_MagazineManagementView__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-MagazineManagementView-idx" */ '@/pages/ResourceManagement/MagazineManagementView/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagementMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementMod-idx" */ '@/pages/ResourceManagement/NewsLetterManagementMod/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagementView__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementView-idx" */ '@/pages/ResourceManagement/NewsLetterManagementView/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagementView_tab1__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementView_tab1-idx" */ '@/pages/ResourceManagement/NewsLetterManagementView_tab1/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagementView_tab2__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementView_tab2-idx" */ '@/pages/ResourceManagement/NewsLetterManagementView_tab2/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagementView_tab3__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementView_tab3-idx" */ '@/pages/ResourceManagement/NewsLetterManagementView_tab3/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagementView_tab4__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementView_tab4-idx" */ '@/pages/ResourceManagement/NewsLetterManagementView_tab4/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagementView_tab5__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagementView_tab5-idx" */ '@/pages/ResourceManagement/NewsLetterManagementView_tab5/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagement_tab1__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagement_tab1-idx" */ '@/pages/ResourceManagement/NewsLetterManagement_tab1/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagement_tab2__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagement_tab2-idx" */ '@/pages/ResourceManagement/NewsLetterManagement_tab2/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagement_tab3__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagement_tab3-idx" */ '@/pages/ResourceManagement/NewsLetterManagement_tab3/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagement_tab4__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagement_tab4-idx" */ '@/pages/ResourceManagement/NewsLetterManagement_tab4/_idx.vue'
  )
}
function ResourceManagement_NewsLetterManagement_tab5__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-NewsLetterManagement_tab5-idx" */ '@/pages/ResourceManagement/NewsLetterManagement_tab5/_idx.vue'
  )
}
function ResourceManagement_StudioReservationMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-StudioReservationMod-idx" */ '@/pages/ResourceManagement/StudioReservationMod/_idx.vue'
  )
}
function ResourceManagement_TextbookMaintenanceMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TextbookMaintenanceMod-idx" */ '@/pages/ResourceManagement/TextbookMaintenanceMod/_idx.vue'
  )
}
function ResourceManagement_TextbookMaintenanceView__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TextbookMaintenanceView-idx" */ '@/pages/ResourceManagement/TextbookMaintenanceView/_idx.vue'
  )
}
function ResourceManagement_TextbookRentalMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TextbookRentalMod-idx" */ '@/pages/ResourceManagement/TextbookRentalMod/_idx.vue'
  )
}
function ResourceManagement_TextbookRentalView__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TextbookRentalView-idx" */ '@/pages/ResourceManagement/TextbookRentalView/_idx.vue'
  )
}
function ResourceManagement_TutorTextbookMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TutorTextbookMod-idx" */ '@/pages/ResourceManagement/TutorTextbookMod/_idx.vue'
  )
}
function ResourceManagement_TutorTextbookView__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-TutorTextbookView-idx" */ '@/pages/ResourceManagement/TutorTextbookView/_idx.vue'
  )
}
function ResourceManagement_VehicleReservationMod__idx() {
  return import(
    /* webpackChunkName: "page-ResourceManagement-VehicleReservationMod-idx" */ '@/pages/ResourceManagement/VehicleReservationMod/_idx.vue'
  )
}
function TaskManagement_TaskMod__idx() {
  return import(
    /* webpackChunkName: "page-TaskManagement-TaskMod-idx" */ '@/pages/TaskManagement/TaskMod/_idx.vue'
  )
}
function TaskManagement_TaskView__idx() {
  return import(
    /* webpackChunkName: "page-TaskManagement-TaskView-idx" */ '@/pages/TaskManagement/TaskView/_idx.vue'
  )
}
function customerManagement_businessCardMod__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-businessCardMod-idx" */ '@/pages/customerManagement/businessCardMod/_idx.vue'
  )
}
function customerManagement_businessCardView__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-businessCardView-idx" */ '@/pages/customerManagement/businessCardView/_idx.vue'
  )
}
function customerManagement_customerDBEdit__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-customerDBEdit-idx" */ '@/pages/customerManagement/customerDBEdit/_idx.vue'
  )
}
function customerManagement_customerDBViewTab1__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-customerDBViewTab1-idx" */ '@/pages/customerManagement/customerDBViewTab1/_idx.vue'
  )
}
function customerManagement_customerDBViewTab2__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-customerDBViewTab2-idx" */ '@/pages/customerManagement/customerDBViewTab2/_idx.vue'
  )
}
function customerManagement_customerDBViewTab3__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-customerDBViewTab3-idx" */ '@/pages/customerManagement/customerDBViewTab3/_idx.vue'
  )
}
function customerManagement_outsideWorkAdd__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-outsideWorkAdd-idx" */ '@/pages/customerManagement/outsideWorkAdd/_idx.vue'
  )
}
function customerManagement_outsideWorkMod__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-outsideWorkMod-idx" */ '@/pages/customerManagement/outsideWorkMod/_idx.vue'
  )
}
function customerManagement_outsideWorkView__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-outsideWorkView-idx" */ '@/pages/customerManagement/outsideWorkView/_idx.vue'
  )
}
function customerManagement_scheduleOutsideWorkAdd__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-scheduleOutsideWorkAdd-idx" */ '@/pages/customerManagement/scheduleOutsideWorkAdd/_idx.vue'
  )
}
function customerManagement_scheduleVisitMod__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-scheduleVisitMod-idx" */ '@/pages/customerManagement/scheduleVisitMod/_idx.vue'
  )
}
function customerManagement_scheduleVisitView__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-scheduleVisitView-idx" */ '@/pages/customerManagement/scheduleVisitView/_idx.vue'
  )
}
function customerManagement_statusSMPMod__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-statusSMPMod-idx" */ '@/pages/customerManagement/statusSMPMod/_idx.vue'
  )
}
function customerManagement_statusSMPView__idx() {
  return import(
    /* webpackChunkName: "page-customerManagement-statusSMPView-idx" */ '@/pages/customerManagement/statusSMPView/_idx.vue'
  )
}
function documents_Document__id() {
  return import(
    /* webpackChunkName: "page-documents-Document-id" */ '@/pages/documents/Document/_id.vue'
  )
}
function myPIMS_AssetManagementEdit__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-AssetManagementEdit-idx" */ '@/pages/myPIMS/AssetManagementEdit/_idx.vue'
  )
}
function myPIMS_AssetManagementReportEdit__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-AssetManagementReportEdit-idx" */ '@/pages/myPIMS/AssetManagementReportEdit/_idx.vue'
  )
}
function myPIMS_EducationMod__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-EducationMod-idx" */ '@/pages/myPIMS/EducationMod/_idx.vue'
  )
}
function myPIMS_EicnView__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-EicnView-idx" */ '@/pages/myPIMS/EicnView/_idx.vue'
  )
}
function myPIMS_GoodsRentalMod__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-GoodsRentalMod-idx" */ '@/pages/myPIMS/GoodsRentalMod/_idx.vue'
  )
}
function myPIMS_KPIView__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-KPIView-idx" */ '@/pages/myPIMS/KPIView/_idx.vue'
  )
}
function myPIMS_KPIev__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-KPIev-idx" */ '@/pages/myPIMS/KPIev/_idx.vue'
  )
}
function myPIMS_MCGAdd__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-MCGAdd-idx" */ '@/pages/myPIMS/MCGAdd/_idx.vue'
  )
}
function myPIMS_MCRAdd__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-MCRAdd-idx" */ '@/pages/myPIMS/MCRAdd/_idx.vue'
  )
}
function myPIMS_MCRMCGView__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-MCRMCGView-idx" */ '@/pages/myPIMS/MCRMCGView/_idx.vue'
  )
}
function myPIMS_PBCView__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-PBCView-idx" */ '@/pages/myPIMS/PBCView/_idx.vue'
  )
}
function myPIMS_PBCev__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-PBCev-idx" */ '@/pages/myPIMS/PBCev/_idx.vue'
  )
}
function myPIMS_PersonalInfoList_tab1__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-PersonalInfoList_tab1-idx" */ '@/pages/myPIMS/PersonalInfoList_tab1/_idx.vue'
  )
}
function myPIMS_PersonalInfoList_tab2__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-PersonalInfoList_tab2-idx" */ '@/pages/myPIMS/PersonalInfoList_tab2/_idx.vue'
  )
}
function myPIMS_PersonalInfoList_tab3__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-PersonalInfoList_tab3-idx" */ '@/pages/myPIMS/PersonalInfoList_tab3/_idx.vue'
  )
}
function myPIMS_PersonalInfoList_tab4__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-PersonalInfoList_tab4-idx" */ '@/pages/myPIMS/PersonalInfoList_tab4/_idx.vue'
  )
}
function myPIMS_PersonalInfoList_tab5__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-PersonalInfoList_tab5-idx" */ '@/pages/myPIMS/PersonalInfoList_tab5/_idx.vue'
  )
}
function myPIMS_VacationMgrInfo__idx() {
  return import(
    /* webpackChunkName: "page-myPIMS-VacationMgrInfo-idx" */ '@/pages/myPIMS/VacationMgrInfo/_idx.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
  },
  {
    name: 'about',
    path: 'about',
    component: about,
  },
  {
    name: 'authLogin',
    path: 'authLogin',
    component: authLogin,
  },
  {
    name: 'emp_number',
    path: 'emp_number',
    component: emp_number,
  },
  {
    name: 'emp_number_intranet',
    path: 'emp_number_intranet',
    component: emp_number_intranet,
  },
  {
    name: 'familysite_admin',
    path: 'familysite_admin',
    component: familysite_admin,
  },
  {
    name: 'gate_login',
    path: 'gate_login',
    component: gate_login,
  },
  {
    name: 'index copy',
    path: 'index copy',
    component: index_copy,
  },
  {
    name: 'leadership',
    path: 'leadership',
    component: leadership,
  },
  {
    name: 'leadership_apply',
    path: 'leadership_apply',
    component: leadership_apply,
  },
  {
    name: 'login',
    path: 'login',
    component: login,
  },
  {
    name: 'main',
    path: 'main',
    component: main,
  },
  {
    name: 'pwdChange',
    path: 'pwdChange',
    component: pwdChange,
  },
  {
    name: 'stage (원본)',
    path: 'stage (원본)',
    component: stage_____,
  },
  {
    name: 'stage',
    path: 'stage',
    component: stage,
  },
  {
    name: 'system_select',
    path: 'system_select',
    component: system_select,
  },
  {
    name: 'test',
    path: 'test',
    component: test,
  },
  {
    name: 'BusinessManagement-ERAdd',
    path: 'BusinessManagement/ERAdd',
    component: BusinessManagement_ERAdd,
  },
  {
    name: 'BusinessManagement-ERList',
    path: 'BusinessManagement/ERList',
    component: BusinessManagement_ERList,
  },
  {
    name: 'BusinessManagement-ManagementPlanAdd',
    path: 'BusinessManagement/ManagementPlanAdd',
    component: BusinessManagement_ManagementPlanAdd,
  },
  {
    name: 'BusinessManagement-ManagementPlanList',
    path: 'BusinessManagement/ManagementPlanList',
    component: BusinessManagement_ManagementPlanList,
  },
  {
    name: 'BusinessManagement-ResearchAdd',
    path: 'BusinessManagement/ResearchAdd',
    component: BusinessManagement_ResearchAdd,
  },
  {
    name: 'BusinessManagement-ResearchList',
    path: 'BusinessManagement/ResearchList',
    component: BusinessManagement_ResearchList,
  },
  {
    name: 'BusinessManagement-SPACAdd',
    path: 'BusinessManagement/SPACAdd',
    component: BusinessManagement_SPACAdd,
  },
  {
    name: 'BusinessManagement-SPACList',
    path: 'BusinessManagement/SPACList',
    component: BusinessManagement_SPACList,
  },
  {
    name: 'BusinessManagement-eLearningAdd',
    path: 'BusinessManagement/eLearningAdd',
    component: BusinessManagement_eLearningAdd,
  },
  {
    name: 'BusinessManagement-eLearningList',
    path: 'BusinessManagement/eLearningList',
    component: BusinessManagement_eLearningList,
  },
  {
    name: 'CARROTZone-CEOMessageAdd',
    path: 'CARROTZone/CEOMessageAdd',
    component: CARROTZone_CEOMessageAdd,
  },
  {
    name: 'CARROTZone-CEOMessageList',
    path: 'CARROTZone/CEOMessageList',
    component: CARROTZone_CEOMessageList,
  },
  {
    name: 'CARROTZone-CarrotManualAdd',
    path: 'CARROTZone/CarrotManualAdd',
    component: CARROTZone_CarrotManualAdd,
  },
  {
    name: 'CARROTZone-CarrotManualList',
    path: 'CARROTZone/CarrotManualList',
    component: CARROTZone_CarrotManualList,
  },
  {
    name: 'CARROTZone-MediaZoneAdd',
    path: 'CARROTZone/MediaZoneAdd',
    component: CARROTZone_MediaZoneAdd,
  },
  {
    name: 'CARROTZone-MediaZoneList',
    path: 'CARROTZone/MediaZoneList',
    component: CARROTZone_MediaZoneList,
  },
  {
    name: 'CARROTZone-NoticeAdd',
    path: 'CARROTZone/NoticeAdd',
    component: CARROTZone_NoticeAdd,
  },
  {
    name: 'CARROTZone-NoticeList',
    path: 'CARROTZone/NoticeList',
    component: CARROTZone_NoticeList,
  },
  {
    name: 'ResourceManagement-ClassroomReservationAdd',
    path: 'ResourceManagement/ClassroomReservationAdd',
    component: ResourceManagement_ClassroomReservationAdd,
  },
  {
    name: 'ResourceManagement-ClassroomReservationDate',
    path: 'ResourceManagement/ClassroomReservationDate',
    component: ResourceManagement_ClassroomReservationDate,
  },
  {
    name: 'ResourceManagement-ClassroomReservationMonth',
    path: 'ResourceManagement/ClassroomReservationMonth',
    component: ResourceManagement_ClassroomReservationMonth,
  },
  {
    name: 'ResourceManagement-ClassroomReservationStatistics',
    path: 'ResourceManagement/ClassroomReservationStatistics',
    component: ResourceManagement_ClassroomReservationStatistics,
  },
  {
    name: 'ResourceManagement-ClassroomReservationWeek',
    path: 'ResourceManagement/ClassroomReservationWeek',
    component: ResourceManagement_ClassroomReservationWeek,
  },
  {
    name: 'ResourceManagement-FuelCostMangementList',
    path: 'ResourceManagement/FuelCostMangementList',
    component: ResourceManagement_FuelCostMangementList,
  },
  {
    name: 'ResourceManagement-MIScheduleAdd',
    path: 'ResourceManagement/MIScheduleAdd',
    component: ResourceManagement_MIScheduleAdd,
  },
  {
    name: 'ResourceManagement-MIScheduleDate',
    path: 'ResourceManagement/MIScheduleDate',
    component: ResourceManagement_MIScheduleDate,
  },
  {
    name: 'ResourceManagement-MIScheduleMonth',
    path: 'ResourceManagement/MIScheduleMonth',
    component: ResourceManagement_MIScheduleMonth,
  },
  {
    name: 'ResourceManagement-MIVacationAdd',
    path: 'ResourceManagement/MIVacationAdd',
    component: ResourceManagement_MIVacationAdd,
  },
  {
    name: 'ResourceManagement-MagazineManagementAdd',
    path: 'ResourceManagement/MagazineManagementAdd',
    component: ResourceManagement_MagazineManagementAdd,
  },
  {
    name: 'ResourceManagement-MagazineManagementList',
    path: 'ResourceManagement/MagazineManagementList',
    component: ResourceManagement_MagazineManagementList,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementAdd',
    path: 'ResourceManagement/NewsLetterManagementAdd',
    component: ResourceManagement_NewsLetterManagementAdd,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementList',
    path: 'ResourceManagement/NewsLetterManagementList',
    component: ResourceManagement_NewsLetterManagementList,
  },
  {
    name: 'ResourceManagement-ReturnStatusMaintenanceList',
    path: 'ResourceManagement/ReturnStatusMaintenanceList',
    component: ResourceManagement_ReturnStatusMaintenanceList,
  },
  {
    name: 'ResourceManagement-ShipmentStatusMaintenanceAdd',
    path: 'ResourceManagement/ShipmentStatusMaintenanceAdd',
    component: ResourceManagement_ShipmentStatusMaintenanceAdd,
  },
  {
    name: 'ResourceManagement-ShipmentStatusMaintenanceList',
    path: 'ResourceManagement/ShipmentStatusMaintenanceList',
    component: ResourceManagement_ShipmentStatusMaintenanceList,
  },
  {
    name: 'ResourceManagement-ShipmentStatusMaintenanceView',
    path: 'ResourceManagement/ShipmentStatusMaintenanceView',
    component: ResourceManagement_ShipmentStatusMaintenanceView,
  },
  {
    name: 'ResourceManagement-StudioReservationAdd',
    path: 'ResourceManagement/StudioReservationAdd',
    component: ResourceManagement_StudioReservationAdd,
  },
  {
    name: 'ResourceManagement-StudioReservationMonth',
    path: 'ResourceManagement/StudioReservationMonth',
    component: ResourceManagement_StudioReservationMonth,
  },
  {
    name: 'ResourceManagement-TextbookRentalAdd',
    path: 'ResourceManagement/TextbookRentalAdd',
    component: ResourceManagement_TextbookRentalAdd,
  },
  {
    name: 'ResourceManagement-TextbookRentalList',
    path: 'ResourceManagement/TextbookRentalList',
    component: ResourceManagement_TextbookRentalList,
  },
  {
    name: 'ResourceManagement-TextbookReturnList',
    path: 'ResourceManagement/TextbookReturnList',
    component: ResourceManagement_TextbookReturnList,
  },
  {
    name: 'ResourceManagement-TextbookStatisticsList',
    path: 'ResourceManagement/TextbookStatisticsList',
    component: ResourceManagement_TextbookStatisticsList,
  },
  {
    name: 'ResourceManagement-TutorTextbookAdd',
    path: 'ResourceManagement/TutorTextbookAdd',
    component: ResourceManagement_TutorTextbookAdd,
  },
  {
    name: 'ResourceManagement-TutorTextbookList',
    path: 'ResourceManagement/TutorTextbookList',
    component: ResourceManagement_TutorTextbookList,
  },
  {
    name: 'ResourceManagement-VehicleReservationAdd',
    path: 'ResourceManagement/VehicleReservationAdd',
    component: ResourceManagement_VehicleReservationAdd,
  },
  {
    name: 'ResourceManagement-VehicleReservationLogDay',
    path: 'ResourceManagement/VehicleReservationLogDay',
    component: ResourceManagement_VehicleReservationLogDay,
  },
  {
    name: 'ResourceManagement-VehicleReservationLogMonth',
    path: 'ResourceManagement/VehicleReservationLogMonth',
    component: ResourceManagement_VehicleReservationLogMonth,
  },
  {
    name: 'ResourceManagement-textbookMaintenanceAdd',
    path: 'ResourceManagement/textbookMaintenanceAdd',
    component: ResourceManagement_textbookMaintenanceAdd,
  },
  {
    name: 'ResourceManagement-textbookMaintenanceList',
    path: 'ResourceManagement/textbookMaintenanceList',
    component: ResourceManagement_textbookMaintenanceList,
  },
  {
    name: 'TaskManagement-taskAdd',
    path: 'TaskManagement/taskAdd',
    component: TaskManagement_taskAdd,
  },
  {
    name: 'TaskManagement-taskList',
    path: 'TaskManagement/taskList',
    component: TaskManagement_taskList,
  },
  {
    name: 'customerManagement-businessCardAdd',
    path: 'customerManagement/businessCardAdd',
    component: customerManagement_businessCardAdd,
  },
  {
    name: 'customerManagement-businessCardList',
    path: 'customerManagement/businessCardList',
    component: customerManagement_businessCardList,
  },
  {
    name: 'customerManagement-customerDBAdd',
    path: 'customerManagement/customerDBAdd',
    component: customerManagement_customerDBAdd,
  },
  {
    name: 'customerManagement-customerDBList',
    path: 'customerManagement/customerDBList',
    component: customerManagement_customerDBList,
  },
  {
    name: 'customerManagement-customerStatus',
    path: 'customerManagement/customerStatus',
    component: customerManagement_customerStatus,
  },
  {
    name: 'customerManagement-inboundDashboard',
    path: 'customerManagement/inboundDashboard',
    component: customerManagement_inboundDashboard,
  },
  {
    name: 'customerManagement-scheduleVisitAdd',
    path: 'customerManagement/scheduleVisitAdd',
    component: customerManagement_scheduleVisitAdd,
  },
  {
    name: 'customerManagement-scheduleVisitList',
    path: 'customerManagement/scheduleVisitList',
    component: customerManagement_scheduleVisitList,
  },
  {
    name: 'customerManagement-scheduleVisitMonthly',
    path: 'customerManagement/scheduleVisitMonthly',
    component: customerManagement_scheduleVisitMonthly,
  },
  {
    name: 'customerManagement-scheduleVisitStatus',
    path: 'customerManagement/scheduleVisitStatus',
    component: customerManagement_scheduleVisitStatus,
  },
  {
    name: 'customerManagement-scheduleVisitWeekly',
    path: 'customerManagement/scheduleVisitWeekly',
    component: customerManagement_scheduleVisitWeekly,
  },
  {
    name: 'customerManagement-statusCarrotTotalSalesList',
    path: 'customerManagement/statusCarrotTotalSalesList',
    component: customerManagement_statusCarrotTotalSalesList,
  },
  {
    name: 'customerManagement-statusCarrotTotalSalesList2',
    path: 'customerManagement/statusCarrotTotalSalesList2',
    component: customerManagement_statusCarrotTotalSalesList2,
  },
  {
    name: 'customerManagement-statusSMPAdd',
    path: 'customerManagement/statusSMPAdd',
    component: customerManagement_statusSMPAdd,
  },
  {
    name: 'customerManagement-statusSMPList',
    path: 'customerManagement/statusSMPList',
    component: customerManagement_statusSMPList,
  },
  {
    name: 'documents-AllDocumentList',
    path: 'documents/AllDocumentList',
    component: documents_AllDocumentList,
  },
  {
    name: 'documents-AllExpenseList',
    path: 'documents/AllExpenseList',
    component: documents_AllExpenseList,
  },
  {
    name: 'documents-AllExtraPayList',
    path: 'documents/AllExtraPayList',
    component: documents_AllExtraPayList,
  },
  {
    name: 'documents-AllStatisticsList',
    path: 'documents/AllStatisticsList',
    component: documents_AllStatisticsList,
  },
  {
    name: 'documents-DeptInboxList',
    path: 'documents/DeptInboxList',
    component: documents_DeptInboxList,
  },
  {
    name: 'documents-DraftingAdd',
    path: 'documents/DraftingAdd',
    component: documents_DraftingAdd,
  },
  {
    name: 'documents-DraftingAdd1',
    path: 'documents/DraftingAdd1',
    component: documents_DraftingAdd1,
  },
  {
    name: 'documents-DraftingAdd10',
    path: 'documents/DraftingAdd10',
    component: documents_DraftingAdd10,
  },
  {
    name: 'documents-DraftingAdd2',
    path: 'documents/DraftingAdd2',
    component: documents_DraftingAdd2,
  },
  {
    name: 'documents-DraftingAdd3',
    path: 'documents/DraftingAdd3',
    component: documents_DraftingAdd3,
  },
  {
    name: 'documents-DraftingAdd4',
    path: 'documents/DraftingAdd4',
    component: documents_DraftingAdd4,
  },
  {
    name: 'documents-DraftingAdd5',
    path: 'documents/DraftingAdd5',
    component: documents_DraftingAdd5,
  },
  {
    name: 'documents-DraftingAdd6',
    path: 'documents/DraftingAdd6',
    component: documents_DraftingAdd6,
  },
  {
    name: 'documents-DraftingAdd7',
    path: 'documents/DraftingAdd7',
    component: documents_DraftingAdd7,
  },
  {
    name: 'documents-DraftingAdd8',
    path: 'documents/DraftingAdd8',
    component: documents_DraftingAdd8,
  },
  {
    name: 'documents-DraftingAdd9',
    path: 'documents/DraftingAdd9',
    component: documents_DraftingAdd9,
  },
  {
    name: 'documents-ExpenseInputAdd',
    path: 'documents/ExpenseInputAdd',
    component: documents_ExpenseInputAdd,
  },
  {
    name: 'documents-MyExpenseManagement',
    path: 'documents/MyExpenseManagement',
    component: documents_MyExpenseManagement,
  },
  {
    name: 'documents-MyExtraPayManagement',
    path: 'documents/MyExtraPayManagement',
    component: documents_MyExtraPayManagement,
  },
  {
    name: 'documents-SalesManagementNotPublishList',
    path: 'documents/SalesManagementNotPublishList',
    component: documents_SalesManagementNotPublishList,
  },
  {
    name: 'documents-SalesManagementPublishAdd',
    path: 'documents/SalesManagementPublishAdd',
    component: documents_SalesManagementPublishAdd,
  },
  {
    name: 'documents-SalesManagementPublishList',
    path: 'documents/SalesManagementPublishList',
    component: documents_SalesManagementPublishList,
  },
  {
    name: 'documents-SalesManagementPublishView',
    path: 'documents/SalesManagementPublishView',
    component: documents_SalesManagementPublishView,
  },
  {
    name: 'documents-TotalSalesAmountList',
    path: 'documents/TotalSalesAmountList',
    component: documents_TotalSalesAmountList,
  },
  {
    name: 'myPIMS-AllVacationList',
    path: 'myPIMS/AllVacationList',
    component: myPIMS_AllVacationList,
  },
  {
    name: 'myPIMS-AssetDisposalList',
    path: 'myPIMS/AssetDisposalList',
    component: myPIMS_AssetDisposalList,
  },
  {
    name: 'myPIMS-AssetManagementAdd',
    path: 'myPIMS/AssetManagementAdd',
    component: myPIMS_AssetManagementAdd,
  },
  {
    name: 'myPIMS-AssetManagementList',
    path: 'myPIMS/AssetManagementList',
    component: myPIMS_AssetManagementList,
  },
  {
    name: 'myPIMS-AssetManagementReportAdd',
    path: 'myPIMS/AssetManagementReportAdd',
    component: myPIMS_AssetManagementReportAdd,
  },
  {
    name: 'myPIMS-AssetManagementReportList',
    path: 'myPIMS/AssetManagementReportList',
    component: myPIMS_AssetManagementReportList,
  },
  {
    name: 'myPIMS-AssetReportList',
    path: 'myPIMS/AssetReportList',
    component: myPIMS_AssetReportList,
  },
  {
    name: 'myPIMS-CommunicationPledge',
    path: 'myPIMS/CommunicationPledge',
    component: myPIMS_CommunicationPledge,
  },
  {
    name: 'myPIMS-EducationAdd',
    path: 'myPIMS/EducationAdd',
    component: myPIMS_EducationAdd,
  },
  {
    name: 'myPIMS-EducationDashboard',
    path: 'myPIMS/EducationDashboard',
    component: myPIMS_EducationDashboard,
  },
  {
    name: 'myPIMS-EducationList',
    path: 'myPIMS/EducationList',
    component: myPIMS_EducationList,
  },
  {
    name: 'myPIMS-EmployeeAdd',
    path: 'myPIMS/EmployeeAdd',
    component: myPIMS_EmployeeAdd,
  },
  {
    name: 'myPIMS-FeedbackList',
    path: 'myPIMS/FeedbackList',
    component: myPIMS_FeedbackList,
  },
  {
    name: 'myPIMS-GoodsRentalAdd',
    path: 'myPIMS/GoodsRentalAdd',
    component: myPIMS_GoodsRentalAdd,
  },
  {
    name: 'myPIMS-GoodsRentalList_tab1',
    path: 'myPIMS/GoodsRentalList_tab1',
    component: myPIMS_GoodsRentalList_tab1,
  },
  {
    name: 'myPIMS-GoodsRentalList_tab2',
    path: 'myPIMS/GoodsRentalList_tab2',
    component: myPIMS_GoodsRentalList_tab2,
  },
  {
    name: 'myPIMS-HeadTeamManagement',
    path: 'myPIMS/HeadTeamManagement',
    component: myPIMS_HeadTeamManagement,
  },
  {
    name: 'myPIMS-HeadTeamManagement22',
    path: 'myPIMS/HeadTeamManagement22',
    component: myPIMS_HeadTeamManagement22,
  },
  {
    name: 'myPIMS-HoliDayGift',
    path: 'myPIMS/HoliDayGift',
    component: myPIMS_HoliDayGift,
  },
  {
    name: 'myPIMS-HolidayList',
    path: 'myPIMS/HolidayList',
    component: myPIMS_HolidayList,
  },
  {
    name: 'myPIMS-IMOverallstatisticsList',
    path: 'myPIMS/IMOverallstatisticsList',
    component: myPIMS_IMOverallstatisticsList,
  },
  {
    name: 'myPIMS-IncumbentManagementList',
    path: 'myPIMS/IncumbentManagementList',
    component: myPIMS_IncumbentManagementList,
  },
  {
    name: 'myPIMS-JobRotationManagementList',
    path: 'myPIMS/JobRotationManagementList',
    component: myPIMS_JobRotationManagementList,
  },
  {
    name: 'myPIMS-KPIAdd',
    path: 'myPIMS/KPIAdd',
    component: myPIMS_KPIAdd,
  },
  {
    name: 'myPIMS-MCGList',
    path: 'myPIMS/MCGList',
    component: myPIMS_MCGList,
  },
  {
    name: 'myPIMS-MCRList',
    path: 'myPIMS/MCRList',
    component: myPIMS_MCRList,
  },
  {
    name: 'myPIMS-MyCommunicationPledge',
    path: 'myPIMS/MyCommunicationPledge',
    component: myPIMS_MyCommunicationPledge,
  },
  {
    name: 'myPIMS-PBCAdd',
    path: 'myPIMS/PBCAdd',
    component: myPIMS_PBCAdd,
  },
  {
    name: 'myPIMS-PBCKPIList',
    path: 'myPIMS/PBCKPIList',
    component: myPIMS_PBCKPIList,
  },
  {
    name: 'myPIMS-RecruitList',
    path: 'myPIMS/RecruitList',
    component: myPIMS_RecruitList,
  },
  {
    name: 'myPIMS-RetireeManagementList',
    path: 'myPIMS/RetireeManagementList',
    component: myPIMS_RetireeManagementList,
  },
  {
    name: 'myPIMS-TeamEvaluationManagementList',
    path: 'myPIMS/TeamEvaluationManagementList',
    component: myPIMS_TeamEvaluationManagementList,
  },
  {
    name: 'myPIMS-TeamVacationList',
    path: 'myPIMS/TeamVacationList',
    component: myPIMS_TeamVacationList,
  },
  {
    name: 'myPIMS-TelecommutingList',
    path: 'myPIMS/TelecommutingList',
    component: myPIMS_TelecommutingList,
  },
  {
    name: 'myPIMS-VacationLog',
    path: 'myPIMS/VacationLog',
    component: myPIMS_VacationLog,
  },
  {
    name: 'myPIMS-VacationManagement',
    path: 'myPIMS/VacationManagement',
    component: myPIMS_VacationManagement,
  },
  {
    name: 'myPIMS-eicn',
    path: 'myPIMS/eicn',
    component: myPIMS_eicn,
  },
  {
    name: 'myPIMS-myAssetList',
    path: 'myPIMS/myAssetList',
    component: myPIMS_myAssetList,
  },
  {
    name: 'myPIMS-myEduManagemetList',
    path: 'myPIMS/myEduManagemetList',
    component: myPIMS_myEduManagemetList,
  },
  {
    name: 'myPIMS-myVacationList',
    path: 'myPIMS/myVacationList',
    component: myPIMS_myVacationList,
  },
  {
    name: 'personality-MypimsPersonalityAdd',
    path: 'personality/MypimsPersonalityAdd',
    component: personality_MypimsPersonalityAdd,
  },
  {
    name: 'personality-MypimsPersonalityList',
    path: 'personality/MypimsPersonalityList',
    component: personality_MypimsPersonalityList,
  },
  {
    name: 'personality-MypimsPersonalityView',
    path: 'personality/MypimsPersonalityView',
    component: personality_MypimsPersonalityView,
  },
  {
    name: 'BusinessManagement-ERCompleteList-idx',
    path: 'BusinessManagement/ERCompleteList/:idx?',
    component: BusinessManagement_ERCompleteList__idx,
  },
  {
    name: 'BusinessManagement-EREtcList-idx',
    path: 'BusinessManagement/EREtcList/:idx?',
    component: BusinessManagement_EREtcList__idx,
  },
  {
    name: 'BusinessManagement-ERMod-idx',
    path: 'BusinessManagement/ERMod/:idx?',
    component: BusinessManagement_ERMod__idx,
  },
  {
    name: 'BusinessManagement-ERView-idx',
    path: 'BusinessManagement/ERView/:idx?',
    component: BusinessManagement_ERView__idx,
  },
  {
    name: 'BusinessManagement-ManagementPlanMod-idx',
    path: 'BusinessManagement/ManagementPlanMod/:idx?',
    component: BusinessManagement_ManagementPlanMod__idx,
  },
  {
    name: 'BusinessManagement-ManagementPlanView-idx',
    path: 'BusinessManagement/ManagementPlanView/:idx?',
    component: BusinessManagement_ManagementPlanView__idx,
  },
  {
    name: 'BusinessManagement-ResearchMod-idx',
    path: 'BusinessManagement/ResearchMod/:idx?',
    component: BusinessManagement_ResearchMod__idx,
  },
  {
    name: 'BusinessManagement-ResearchView-idx',
    path: 'BusinessManagement/ResearchView/:idx?',
    component: BusinessManagement_ResearchView__idx,
  },
  {
    name: 'BusinessManagement-SPACMod-idx',
    path: 'BusinessManagement/SPACMod/:idx?',
    component: BusinessManagement_SPACMod__idx,
  },
  {
    name: 'BusinessManagement-SPACView-idx',
    path: 'BusinessManagement/SPACView/:idx?',
    component: BusinessManagement_SPACView__idx,
  },
  {
    name: 'BusinessManagement-eLearningMod-idx',
    path: 'BusinessManagement/eLearningMod/:idx?',
    component: BusinessManagement_eLearningMod__idx,
  },
  {
    name: 'BusinessManagement-eLearningView-idx',
    path: 'BusinessManagement/eLearningView/:idx?',
    component: BusinessManagement_eLearningView__idx,
  },
  {
    name: 'CARROTZone-CEOMessageMod-idx',
    path: 'CARROTZone/CEOMessageMod/:idx?',
    component: CARROTZone_CEOMessageMod__idx,
  },
  {
    name: 'CARROTZone-CEOMessageView-idx',
    path: 'CARROTZone/CEOMessageView/:idx?',
    component: CARROTZone_CEOMessageView__idx,
  },
  {
    name: 'CARROTZone-CarrotManualMod-idx',
    path: 'CARROTZone/CarrotManualMod/:idx?',
    component: CARROTZone_CarrotManualMod__idx,
  },
  {
    name: 'CARROTZone-CarrotManualView-idx',
    path: 'CARROTZone/CarrotManualView/:idx?',
    component: CARROTZone_CarrotManualView__idx,
  },
  {
    name: 'CARROTZone-MediaZoneMod-idx',
    path: 'CARROTZone/MediaZoneMod/:idx?',
    component: CARROTZone_MediaZoneMod__idx,
  },
  {
    name: 'CARROTZone-MediaZoneView-idx',
    path: 'CARROTZone/MediaZoneView/:idx?',
    component: CARROTZone_MediaZoneView__idx,
  },
  {
    name: 'CARROTZone-NoticeMod-idx',
    path: 'CARROTZone/NoticeMod/:idx?',
    component: CARROTZone_NoticeMod__idx,
  },
  {
    name: 'CARROTZone-NoticeView-idx',
    path: 'CARROTZone/NoticeView/:idx?',
    component: CARROTZone_NoticeView__idx,
  },
  {
    name: 'ResourceManagement-ClassroomReservationMod-idx',
    path: 'ResourceManagement/ClassroomReservationMod/:idx?',
    component: ResourceManagement_ClassroomReservationMod__idx,
  },
  {
    name: 'ResourceManagement-MIScheduleMod-idx',
    path: 'ResourceManagement/MIScheduleMod/:idx?',
    component: ResourceManagement_MIScheduleMod__idx,
  },
  {
    name: 'ResourceManagement-MIVacationMod-idx',
    path: 'ResourceManagement/MIVacationMod/:idx?',
    component: ResourceManagement_MIVacationMod__idx,
  },
  {
    name: 'ResourceManagement-MagazineManagementMod-idx',
    path: 'ResourceManagement/MagazineManagementMod/:idx?',
    component: ResourceManagement_MagazineManagementMod__idx,
  },
  {
    name: 'ResourceManagement-MagazineManagementView-idx',
    path: 'ResourceManagement/MagazineManagementView/:idx?',
    component: ResourceManagement_MagazineManagementView__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementMod-idx',
    path: 'ResourceManagement/NewsLetterManagementMod/:idx?',
    component: ResourceManagement_NewsLetterManagementMod__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementView-idx',
    path: 'ResourceManagement/NewsLetterManagementView/:idx?',
    component: ResourceManagement_NewsLetterManagementView__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementView_tab1-idx',
    path: 'ResourceManagement/NewsLetterManagementView_tab1/:idx?',
    component: ResourceManagement_NewsLetterManagementView_tab1__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementView_tab2-idx',
    path: 'ResourceManagement/NewsLetterManagementView_tab2/:idx?',
    component: ResourceManagement_NewsLetterManagementView_tab2__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementView_tab3-idx',
    path: 'ResourceManagement/NewsLetterManagementView_tab3/:idx?',
    component: ResourceManagement_NewsLetterManagementView_tab3__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementView_tab4-idx',
    path: 'ResourceManagement/NewsLetterManagementView_tab4/:idx?',
    component: ResourceManagement_NewsLetterManagementView_tab4__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagementView_tab5-idx',
    path: 'ResourceManagement/NewsLetterManagementView_tab5/:idx?',
    component: ResourceManagement_NewsLetterManagementView_tab5__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagement_tab1-idx',
    path: 'ResourceManagement/NewsLetterManagement_tab1/:idx?',
    component: ResourceManagement_NewsLetterManagement_tab1__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagement_tab2-idx',
    path: 'ResourceManagement/NewsLetterManagement_tab2/:idx?',
    component: ResourceManagement_NewsLetterManagement_tab2__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagement_tab3-idx',
    path: 'ResourceManagement/NewsLetterManagement_tab3/:idx?',
    component: ResourceManagement_NewsLetterManagement_tab3__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagement_tab4-idx',
    path: 'ResourceManagement/NewsLetterManagement_tab4/:idx?',
    component: ResourceManagement_NewsLetterManagement_tab4__idx,
  },
  {
    name: 'ResourceManagement-NewsLetterManagement_tab5-idx',
    path: 'ResourceManagement/NewsLetterManagement_tab5/:idx?',
    component: ResourceManagement_NewsLetterManagement_tab5__idx,
  },
  {
    name: 'ResourceManagement-StudioReservationMod-idx',
    path: 'ResourceManagement/StudioReservationMod/:idx?',
    component: ResourceManagement_StudioReservationMod__idx,
  },
  {
    name: 'ResourceManagement-TextbookMaintenanceMod-idx',
    path: 'ResourceManagement/TextbookMaintenanceMod/:idx?',
    component: ResourceManagement_TextbookMaintenanceMod__idx,
  },
  {
    name: 'ResourceManagement-TextbookMaintenanceView-idx',
    path: 'ResourceManagement/TextbookMaintenanceView/:idx?',
    component: ResourceManagement_TextbookMaintenanceView__idx,
  },
  {
    name: 'ResourceManagement-TextbookRentalMod-idx',
    path: 'ResourceManagement/TextbookRentalMod/:idx?',
    component: ResourceManagement_TextbookRentalMod__idx,
  },
  {
    name: 'ResourceManagement-TextbookRentalView-idx',
    path: 'ResourceManagement/TextbookRentalView/:idx?',
    component: ResourceManagement_TextbookRentalView__idx,
  },
  {
    name: 'ResourceManagement-TutorTextbookMod-idx',
    path: 'ResourceManagement/TutorTextbookMod/:idx?',
    component: ResourceManagement_TutorTextbookMod__idx,
  },
  {
    name: 'ResourceManagement-TutorTextbookView-idx',
    path: 'ResourceManagement/TutorTextbookView/:idx?',
    component: ResourceManagement_TutorTextbookView__idx,
  },
  {
    name: 'ResourceManagement-VehicleReservationMod-idx',
    path: 'ResourceManagement/VehicleReservationMod/:idx?',
    component: ResourceManagement_VehicleReservationMod__idx,
  },
  {
    name: 'TaskManagement-TaskMod-idx',
    path: 'TaskManagement/TaskMod/:idx?',
    component: TaskManagement_TaskMod__idx,
  },
  {
    name: 'TaskManagement-TaskView-idx',
    path: 'TaskManagement/TaskView/:idx?',
    component: TaskManagement_TaskView__idx,
  },
  {
    name: 'customerManagement-businessCardMod-idx',
    path: 'customerManagement/businessCardMod/:idx?',
    component: customerManagement_businessCardMod__idx,
  },
  {
    name: 'customerManagement-businessCardView-idx',
    path: 'customerManagement/businessCardView/:idx?',
    component: customerManagement_businessCardView__idx,
  },
  {
    name: 'customerManagement-customerDBEdit-idx',
    path: 'customerManagement/customerDBEdit/:idx?',
    component: customerManagement_customerDBEdit__idx,
  },
  {
    name: 'customerManagement-customerDBViewTab1-idx',
    path: 'customerManagement/customerDBViewTab1/:idx?',
    component: customerManagement_customerDBViewTab1__idx,
  },
  {
    name: 'customerManagement-customerDBViewTab2-idx',
    path: 'customerManagement/customerDBViewTab2/:idx?',
    component: customerManagement_customerDBViewTab2__idx,
  },
  {
    name: 'customerManagement-customerDBViewTab3-idx',
    path: 'customerManagement/customerDBViewTab3/:idx?',
    component: customerManagement_customerDBViewTab3__idx,
  },
  {
    name: 'customerManagement-outsideWorkAdd-idx',
    path: 'customerManagement/outsideWorkAdd/:idx?',
    component: customerManagement_outsideWorkAdd__idx,
  },
  {
    name: 'customerManagement-outsideWorkMod-idx',
    path: 'customerManagement/outsideWorkMod/:idx?',
    component: customerManagement_outsideWorkMod__idx,
  },
  {
    name: 'customerManagement-outsideWorkView-idx',
    path: 'customerManagement/outsideWorkView/:idx?',
    component: customerManagement_outsideWorkView__idx,
  },
  {
    name: 'customerManagement-scheduleOutsideWorkAdd-idx',
    path: 'customerManagement/scheduleOutsideWorkAdd/:idx?',
    component: customerManagement_scheduleOutsideWorkAdd__idx,
  },
  {
    name: 'customerManagement-scheduleVisitMod-idx',
    path: 'customerManagement/scheduleVisitMod/:idx?',
    component: customerManagement_scheduleVisitMod__idx,
  },
  {
    name: 'customerManagement-scheduleVisitView-idx',
    path: 'customerManagement/scheduleVisitView/:idx?',
    component: customerManagement_scheduleVisitView__idx,
  },
  {
    name: 'customerManagement-statusSMPMod-idx',
    path: 'customerManagement/statusSMPMod/:idx?',
    component: customerManagement_statusSMPMod__idx,
  },
  {
    name: 'customerManagement-statusSMPView-idx',
    path: 'customerManagement/statusSMPView/:idx?',
    component: customerManagement_statusSMPView__idx,
  },
  {
    name: 'documents-Document-id',
    path: 'documents/Document/:id?',
    component: documents_Document__id,
  },
  {
    name: 'myPIMS-AssetManagementEdit-idx',
    path: 'myPIMS/AssetManagementEdit/:idx?',
    component: myPIMS_AssetManagementEdit__idx,
  },
  {
    name: 'myPIMS-AssetManagementReportEdit-idx',
    path: 'myPIMS/AssetManagementReportEdit/:idx?',
    component: myPIMS_AssetManagementReportEdit__idx,
  },
  {
    name: 'myPIMS-EducationMod-idx',
    path: 'myPIMS/EducationMod/:idx?',
    component: myPIMS_EducationMod__idx,
  },
  {
    name: 'myPIMS-EicnView-idx',
    path: 'myPIMS/EicnView/:idx?',
    component: myPIMS_EicnView__idx,
  },
  {
    name: 'myPIMS-GoodsRentalMod-idx',
    path: 'myPIMS/GoodsRentalMod/:idx?',
    component: myPIMS_GoodsRentalMod__idx,
  },
  {
    name: 'myPIMS-KPIView-idx',
    path: 'myPIMS/KPIView/:idx?',
    component: myPIMS_KPIView__idx,
  },
  {
    name: 'myPIMS-KPIev-idx',
    path: 'myPIMS/KPIev/:idx?',
    component: myPIMS_KPIev__idx,
  },
  {
    name: 'myPIMS-MCGAdd-idx',
    path: 'myPIMS/MCGAdd/:idx?',
    component: myPIMS_MCGAdd__idx,
  },
  {
    name: 'myPIMS-MCRAdd-idx',
    path: 'myPIMS/MCRAdd/:idx?',
    component: myPIMS_MCRAdd__idx,
  },
  {
    name: 'myPIMS-MCRMCGView-idx',
    path: 'myPIMS/MCRMCGView/:idx?',
    component: myPIMS_MCRMCGView__idx,
  },
  {
    name: 'myPIMS-PBCView-idx',
    path: 'myPIMS/PBCView/:idx?',
    component: myPIMS_PBCView__idx,
  },
  {
    name: 'myPIMS-PBCev-idx',
    path: 'myPIMS/PBCev/:idx?',
    component: myPIMS_PBCev__idx,
  },
  {
    name: 'myPIMS-PersonalInfoList_tab1-idx',
    path: 'myPIMS/PersonalInfoList_tab1/:idx?',
    component: myPIMS_PersonalInfoList_tab1__idx,
  },
  {
    name: 'myPIMS-PersonalInfoList_tab2-idx',
    path: 'myPIMS/PersonalInfoList_tab2/:idx?',
    component: myPIMS_PersonalInfoList_tab2__idx,
  },
  {
    name: 'myPIMS-PersonalInfoList_tab3-idx',
    path: 'myPIMS/PersonalInfoList_tab3/:idx?',
    component: myPIMS_PersonalInfoList_tab3__idx,
  },
  {
    name: 'myPIMS-PersonalInfoList_tab4-idx',
    path: 'myPIMS/PersonalInfoList_tab4/:idx?',
    component: myPIMS_PersonalInfoList_tab4__idx,
  },
  {
    name: 'myPIMS-PersonalInfoList_tab5-idx',
    path: 'myPIMS/PersonalInfoList_tab5/:idx?',
    component: myPIMS_PersonalInfoList_tab5__idx,
  },
  {
    name: 'myPIMS-VacationMgrInfo-idx',
    path: 'myPIMS/VacationMgrInfo/:idx?',
    component: myPIMS_VacationMgrInfo__idx,
  },
]
